export const I18N_KEYS = {
	CREATE_FULL_EDIT_PAGE: {
		page: 'title.add.page',
		blogpost: 'title.add.blogpost',
	},

	EDIT_FULL_EDIT_PAGE: {
		page: 'document-title.edit.name',
		blogpost: 'document-title.edit.name',
	},

	CREATE_TEMPLATE_PAGE: {
		page: 'title.add.page.template',
	},

	EDIT_TEMPLATE_PAGE: {
		page: 'document-title.edit.page.template',
	},
};
